module.exports = __webpack_public_path__ + "media/images/story/top/capture_greetings-19a0ae4d80475773c08c98acbd2d5553.svg";